/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonalityTypeDtoFromJSON, PersonalityTypeDtoToJSON, } from './PersonalityTypeDto.js';
/**
 * Check if a given object implements the ListPersonalityTypesResult interface.
 */
export function instanceOfListPersonalityTypesResult(value) {
    if (!('personalityTypes' in value) || value['personalityTypes'] === undefined)
        return false;
    return true;
}
export function ListPersonalityTypesResultFromJSON(json) {
    return ListPersonalityTypesResultFromJSONTyped(json, false);
}
export function ListPersonalityTypesResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'personalityTypes': (json['personalityTypes'].map(PersonalityTypeDtoFromJSON)),
    };
}
export function ListPersonalityTypesResultToJSON(json) {
    return ListPersonalityTypesResultToJSONTyped(json, false);
}
export function ListPersonalityTypesResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'personalityTypes': (value['personalityTypes'].map(PersonalityTypeDtoToJSON)),
    };
}
